/* Merchandising rails and editorial tiles. Lifted out of bb-drawer.js: they are
   page merchandising, not Quick Shop, and that file had grown too large to
   deploy in one piece. Both still open the ONE shared drawer (ADR-UI-029)
   through the global open() bb-drawer.js defines, and this file is loaded
   after it, so the order they run in is unchanged. */
/* rails — LUSH model: fixed cards, rail overflows and bleeds */
[].forEach.call(document.querySelectorAll('.rail'),function(rail){
  var label = rail.classList.contains('rail--mood') ? 'Shop by Mood' : 'Shop by Scent';
  var track=rail.querySelector('[data-track]'), prev=rail.querySelector('[data-prev]'),
      next=rail.querySelector('[data-next]');
  function step(){ var i=rail.querySelector('.rail__item');
    return i? i.getBoundingClientRect().width+14 : 340; }
  function sync(){ var max=track.scrollWidth-track.clientWidth-2;
    prev.disabled=track.scrollLeft<=2; next.disabled=track.scrollLeft>=max; }
  prev.onclick=function(){ track.scrollBy({left:-step()*2}); };
  next.onclick=function(){ track.scrollBy({left: step()*2}); };
  track.addEventListener('scroll',sync,{passive:true}); window.addEventListener('resize',sync); sync();
  [].forEach.call(rail.querySelectorAll('.rail__card'),function(card){
    var vid=card.querySelector('.mood__video');
    if(vid){ card.addEventListener('mouseenter',function(){vid.play().catch(function(){});});
              card.addEventListener('mouseleave',function(){vid.pause();vid.currentTime=0;}); }
    card.onclick=function(){
      card.setAttribute('aria-pressed','true');
      open({label:label,name:card.dataset.name,key:card.dataset.key,source:card.dataset.source});
    };
  });
});
/* editorial tiles reuse the same modal */
[].forEach.call(document.querySelectorAll('.edit__tile'),function(t){
  t.onclick=function(){ open({label:'Shop the Story',name:t.dataset.name,
    key:t.dataset.key,source:'handles'}); };
});
